module.exports = __webpack_public_path__ + "static/media/cherry.71b590ac.svg";